import apiService from '@/services/apiService';

const actions = {
  getOurServices({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('our-service')
        .then((response) => {
          commit('getOurServices', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getSVG({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('our-service/get-svg', payload)
        .then((response) => {
          // commit('getOurServices', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getOurService({ commit }, payload) {
    apiService.get(`our-service/${payload}`)
      .then((response) => {
        commit('getOurService', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  orderOurService({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`our-service/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postOurService({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('our-service', payload)
        .then((response) => {
          commit('postOurService', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putOurService({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`our-service/${payload.id}`, payload.formData)
        .then((response) => {
          commit('putOurService', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delOurService({ commit }, payload) {
    apiService.delete(`our-service/${payload}`)
      .then((response) => {
        commit('delOurService', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
